export default __webpack_public_path__ + "static/media/13.250e0804.jpg";